// extracted by mini-css-extract-plugin
module.exports = {"sidebarMainLink":"sidebarnavlink_sidebarMainLink__2vM_F","sidebarLinkActive":"sidebarnavlink_sidebarLinkActive__10H4b","sidebarLinkIcon":"sidebarnavlink_sidebarLinkIcon__2YsSz"};